var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入订单编号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderCode", $$v)
                                },
                                expression: "listPram.orderCode",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth mr20",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderStatus", $$v)
                                },
                                expression: "listPram.orderStatus",
                              },
                            },
                            _vm._l(_vm.orderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "售后状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.saleStateOption, function (item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.description,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "售后类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "type", $$v)
                                },
                                expression: "listPram.type",
                              },
                            },
                            _vm._l(_vm.saleTypeOption, function (item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.description,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-center" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:aftersale:export"],
                          expression: "['admin:order:aftersale:export']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportsAftersale },
                    },
                    [_vm._v("结果导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:aftersale:create"],
                          expression: "['admin:order:aftersale:create']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handerAftersale(0)
                        },
                      },
                    },
                    [_vm._v("创建售后")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatusDesc",
                  label: "订单状态",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusDesc",
                  label: "售后状态",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "aftersaleTypeDesc",
                  label: "售后类型",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "商品名称",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {}, [
                        scope.row.items && scope.row.items.length
                          ? _c(
                              "div",
                              [
                                _vm._l(
                                  scope.row.items,
                                  function (productItem, i) {
                                    return _c(
                                      "div",
                                      {
                                        key: productItem.id,
                                        staticClass: "flex-center",
                                      },
                                      [
                                        i < 4
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "ellipsis1",
                                                staticStyle: {
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid #dfe6ed",
                                                },
                                                attrs: {
                                                  title:
                                                    productItem.productName,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    productItem.productName ||
                                                      "--"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openSkuDetail(
                                          scope.row.items
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "" +
                                          (scope.row.items.length >= 5
                                            ? "还有" +
                                              (scope.row.items.length - 4) +
                                              "个商品，查看全部 >"
                                            : "查看全部 >")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _c("div", [_vm._v("--")]),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "销售属性",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {}, [
                        scope.row.items && scope.row.items.length
                          ? _c(
                              "div",
                              [
                                _vm._l(
                                  scope.row.items,
                                  function (productItem, i) {
                                    return _c(
                                      "div",
                                      {
                                        key: productItem.id,
                                        staticClass: "flex-center",
                                      },
                                      [
                                        i < 4
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "ellipsis1",
                                                staticStyle: {
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid #dfe6ed",
                                                },
                                                attrs: {
                                                  title: productItem.attr,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    productItem.attr || "--"
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openSkuDetail(
                                          scope.row.items
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "" +
                                          (scope.row.items.length >= 5
                                            ? "还有" +
                                              (scope.row.items.length - 4) +
                                              "个商品，查看全部 >"
                                            : "查看全部 >")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _c("div", [_vm._v("--")]),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderPrice",
                  label: "订单金额",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderPayPrice",
                  label: "实付款",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "170",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:aftersale:detail"],
                                expression: "['admin:order:aftersale:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handerAftersale(2, {
                                  aftersaleNo: scope.row.id,
                                  orderNo: scope.row.orderNo,
                                })
                              },
                            },
                          },
                          [_vm._v("售后明细")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 10
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:finace:audit"],
                                    expression: "['admin:finace:audit']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerFinaceAudit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("财务审核")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.auditStatus == 0 &&
                        scope.row.isAudited == 1 &&
                        ![8, 9, 10, 11].includes(Number(scope.row.status))
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerAftersale(1, {
                                      aftersaleNo: scope.row.id,
                                      orderNo: scope.row.orderNo,
                                    })
                                  },
                                },
                              },
                              [_vm._v("售后审核")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ![10, 11].includes(Number(scope.row.status))
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:order:aftersale:tracking:create",
                                    ],
                                    expression:
                                      "['admin:order:aftersale:tracking:create']",
                                  },
                                ],
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goNextState(scope.row)
                                  },
                                },
                              },
                              [_vm._v("添加跟踪")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [4].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:aftersale:refund"],
                                    expression:
                                      "['admin:order:aftersale:refund']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRefund(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("退款操作")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [5, 6].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendOrder(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("退换发货")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        ![7, 8, 11].includes(scope.row.status) &&
                        Number(scope.row.status) !== 10
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openResponsibilityModal(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("售后判责")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("SettingRefund", {
        ref: "SettingRefundRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("NextState", {
        ref: "NextStateRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("FinancePendingAudit", {
        ref: "FinancePendingAuditRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("OpenSkus", { ref: "OpenSkusRef" }),
      _vm._v(" "),
      _c("OrderSend", {
        ref: "OrderSendRef",
        attrs: { showCompany: false, formType: 2 },
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
      _vm._v(" "),
      _c("Compensation", {
        ref: "CompensationRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }